import { useMemo } from 'react';

import { useLookerModelId } from '@/hooks/looker/use-looker-model-id';
import { useLookerSdk } from '@/hooks/useLookerSdk';

import { LookerPCSRepository } from './infra/repositories/looker/looker.pcs.repository';
import { PCSPage } from './view';
import type { Dependencies } from './view/contexts/dependencies.context';

export function PCSModule() {
  const coreSDK = useLookerSdk();
  const model = useLookerModelId();

  const dependencies = useMemo<Dependencies>(
    function () {
      return {
        repositories: {
          pcs: new LookerPCSRepository(coreSDK, model),
          // Add other repositories here...
        },
      };
    },
    [coreSDK, model],
  );

  return <PCSPage dependencies={dependencies} />;
}
